<template src="./AppWeather.template.html"></template>

<script>
    import {months, windDescribe} from './constants.js'
    import { bus } from './bus.js';
    const imagePath = '/images/weather-new/icon-';
    const imageExt = '.svg';
    const mSecInDay = 24 * 60 * 60 * 1000;

    export default {
        name: 'currentWeather',
        data: () => ({
            currentWeather: {},
            listWeather: {},
            currentDate: null,
            nowDate: null,
            previousDate: null,
            isPreviousDisabled: true,
            isNextDisabled: false,
            nextDate: null,
            errors: []
        }),
        created() {
        },
        beforeMount() {
            this.init();
        },
        mounted() {
            bus.$on('change-current-date', this.changeCurrentDate);
        },
        computed: {
            computedWeatherNowIcon: function () {
                return  imagePath+(this.currentWeather.now.icon ? this.currentWeather.now.icon : this.currentWeather.day.icon)+imageExt;
            },
            computedWeatherNowTemperature: function() {
                return  this.currentWeather.now.temperature ? this.currentWeather.now.temperature : this.currentWeather.day.temperature;
            },
            computedWeatherNowDescribe: function() {
                return  this.currentWeather.now.describe ? this.currentWeather.now.describe : this.currentWeather.day.describe;
            },
            computedWeatherNowWind: function() {
                return  this.currentWeather.now.wind ? this.currentWeather.now.wind : this.currentWeather.day.wind;
            },
            computedWeatherNowWindDirection: function() {
                return  this.currentWeather.now.windDirection ? this.currentWeather.now.windDirection : this.currentWeather.day.windDirection;
            },
            computedWeatherMorningIcon: function () {
                return  imagePath + this.currentWeather.morning.icon + imageExt;
            },
            computedWeatherDayIcon: function () {
                return  imagePath + this.currentWeather.day.icon + imageExt;
            },
            computedWeatherEveningIcon: function () {
                return  imagePath + this.currentWeather.evening.icon + imageExt;
            },
            computedWeatherNightIcon: function () {
                return  imagePath + this.currentWeather.night.icon + imageExt;
            },
            computedCurrentDayTitle: function () {
                return  this.isCurrentDayToday() ? 'Сейчас на улице' : this.currentWeather.dayOfMonth;
            },
            computedCurrentDaySubTitle: function () {
                return  this.currentWeather.weekDay + (this.currentWeather.now.temperature ? ' ' + this.currentWeather.dayOfMonth : '');
            },
            computedPreviousDayTitle: function () {

                return this.isCurrentDayToday()
                ? 'вчера'
                : (this.previousDate).getDate() + ' ' + this.getMonthByNumber((this.previousDate).getMonth());
            },
            computedNextDayTitle: function () {
                return this.isCurrentDayToday()
                    ? 'завтра'
                    : (this.nextDate).getDate() + ' ' + this.getMonthByNumber((this.nextDate).getMonth());
            },
            computedNowWindDescribe: function () {
                return this.currentWeather.now.wind
                        ? windDescribe[this.currentWeather.now.windDirection] + ' '+ this.currentWeather.now.wind + ' м/c'
                        : windDescribe[this.currentWeather.day.windDirection] + ' '+ this.currentWeather.day.wind + ' м/c';
            },
        },
        methods: {
            init: function () {
                this.currentWeather = this.$root.currentWeather;
                this.listWeather = this.$root.listWeather;

                this.formatEndSetCurrentDate(new Date());
                this.nowDate = this.currentDate;
            },
            loadParameters() {

            },
            formatEndSetCurrentDate(date){
                date.setHours(0);
                date.setMinutes(0);
                date.setSeconds(0);
                date.setMilliseconds(0);
                this.currentDate = date;
                this.setCurrentDate();
            },

            changeCurrentDate(date) {
                if(date in this.listWeather){
                    this.currentWeather = this.listWeather[date];
                    let currentDate = new Date(Date.parse(date));
                    this.formatEndSetCurrentDate(currentDate);
                }

            },
            setCurrentDate() {
                this.previousDate = new Date( (this.currentDate).getTime()-mSecInDay);
                this.nextDate = new Date( (this.currentDate).getTime()+mSecInDay);

                const formatPreviousDate = this.getFormatDate(this.previousDate);
                const formatNextDate = this.getFormatDate(this.nextDate);

                this.isPreviousDisabled = formatPreviousDate in this.listWeather ? false : true;
                this.isNextDisabled = formatNextDate in this.listWeather ? false : true;

            },
            getMonthByNumber(number) {
                return months[number];
            },
            getFormatDate(date) {
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let year = date.getFullYear();

                if (month < 10) { month = "0" + month }
                if (day < 10) { day = "0" + day }

                return year + '-' + month + '-' + day;
            },
            setPreviousDate() {
                const formatPreviousDate = this.getFormatDate(this.previousDate);
                if(formatPreviousDate in this.listWeather){
                    this.currentWeather = this.listWeather[formatPreviousDate];
                    this.currentDate = this.previousDate;
                    this.setCurrentDate();
                }
            },
            setNextDate() {
                const formatNextDate = this.getFormatDate(this.nextDate);
                if(formatNextDate in this.listWeather){
                    this.currentWeather = this.listWeather[formatNextDate];
                    this.currentDate = this.nextDate;
                    this.setCurrentDate();
                }
            },
            computedWindDescribe: function (id, wind) {
                return id in windDescribe ? windDescribe[id] + ' ' + wind +' м/c': '';
            },
            isCurrentDayToday()
            {
                return this.currentDate.getTime() == this.nowDate.getTime();
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/AppWeather.vue